import { typeContractList } from "../api/helpline/keiyaku"
import { typeQaList } from "../api/helpline/qa"

export const initialState = {
  user: {
    userId: '',
    token: '',
    role: '',
    ssFlg: ''
  },
  page: {
    backpage: false,
  },
  qalist: [],
  contractlist: []
}

export type State = typeof initialState

export interface IAction {
  type: 'SET_USER' | 'SET_PAGE' | 'SET_QALIST' | 'SET_CONLIST',
  payload: {
    userId: string,
    token: string,
    role: string,
    ssFlg: string,
  },
  page: {
    backpage: boolean,
  },
  qalist: typeQaList[],
  contractlist: typeContractList[]
}

export const reducer = (state: State, action: IAction) => {
  switch (action.type) {
    case 'SET_USER':
      return { ...state, user: action.payload }
    case 'SET_PAGE':
      return { ...state, page: action.page }
    case 'SET_QALIST':
      return { ...state, qalist: action.qalist }
    case 'SET_CONLIST':
      return { ...state, contractlist: action.contractlist }
    default:
      return state
  }
}